import resourcesToBackend from 'i18next-resources-to-backend';

import { captureException } from '@sentry/browser';
import { i18nLanguageToSmartlingLanguage } from './i18n.config';

/**
 * Whether the language loader is asynchronous.
 */
export const isAsync = true;

/**
 * Locale file loader for web
 */
const webLanguageLoader = () =>
    resourcesToBackend((language, namespace, callback) => {
        const path = i18nLanguageToSmartlingLanguage[language] ?? language;

        import(`../public/locales/${path}/${namespace}.json`)
            .then(({ default: resources }) => callback(null, resources))
            .catch(error => {
                captureException(error);

                callback(error, null);
            });
    });

export { webLanguageLoader as languageLoader };
